import { AwsLambdaIconUrl } from "@p0security/shared/integrations/constants";
import { AwsLambdaNotifierComponents } from "@p0security/shared/integrations/notifiers/aws-lambda/components";
import { AwsIntegration } from "@p0security/shared/integrations/resources/aws/types";
import { useFirestoreDoc } from "providers/FirestoreProvider";
import { useCallback } from "react";

import { Install, InstallProps } from "../Install/Install";
import { awsLambdaNotifierIntegration } from "./install/install";

export const AwsLambda = (
  props: Pick<
    InstallProps<typeof AwsLambdaNotifierComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const itemKind = useCallback(() => "notifier", []);
  const aws = useFirestoreDoc<AwsIntegration>("integrations/aws", {
    tenantAware: true,
  });

  const cspConfigs = { aws };

  return (
    <Install<typeof AwsLambdaNotifierComponents>
      components={AwsLambdaNotifierComponents}
      installer={awsLambdaNotifierIntegration(cspConfigs)}
      integration="aws-lambda-notifier"
      itemKind={itemKind}
      logo={AwsLambdaIconUrl}
      title={"AWS Lambda"}
      {...props}
    />
  );
};
